module.exports = __webpack_public_path__ + "images/5f8d5073bc11db1da58e0f3603c07f17.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/scenes/Shell/scenes/Header/img/IconHome-white.png
// module id = 1273
// module chunks = 0